const yup = require("yup");
const email = require("./email");
const password = require("./password");
const phone = require("./phone");
const onOff = require("./onOff");
const userType = require("./userType");
const passwordConfirm = require("./passwordConfirm");
const name = require("./firstName");
const lastName = require("./lastName");
const agree = require("./agree");
const place = require("./place");
const profileValidation = yup.object().shape({
  email,
  phone,
  // password,
  name,
  lastName,
  marketing: onOff,
  sms: onOff,
  user_type: userType,
});
const registerValidation = yup.object().shape({
  email,
  phone,
  newpassword: password,
  confirmpassword: passwordConfirm,
  name,
  lastName,
  marketing: onOff,
  user_type: userType,
  agree,
  place: place.notRequired(),
  promo: yup.string().notRequired(),
});
const detailsValidation = yup.object().shape({
  phone,
  newpassword: password,
  confirmpassword: passwordConfirm,
  name,
  lastName,
  marketing: onOff,
  agree,
});
const passwordValidation = yup.object().shape({
  newpassword: password,
  confirmpassword: passwordConfirm,
});
const loginValidation = yup.object().shape({
  email,
  password: yup.string().required("A password is required"),
});

module.exports = {
  profileValidation,
  passwordValidation,
  loginValidation,
  registerValidation,
  detailsValidation,
  emailValidation: email,
};
